import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileGroupComponent } from './user-profile-group.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { AccessPointBuildingsModule } from '../access-point-buildings/access-point-buildings.module';
import { AddUserGroupModule } from '../add-user-group/add-user-group.module';
import { AssignDeviceGroupModule } from '../assign-device-group/assign-device-group.module';
import { UserGroupListingModule } from '../user-group-listing/user-group-listing.module';
import { AccessTimeModule } from '../../add-user/access-time/access-time.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';

@NgModule({
  declarations: [UserProfileGroupComponent],
  imports: [
    CommonModule,
    SharedLayoutModule,
    WithTooltipModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ControlDisabledDirectiveModule,
    UserGroupListingModule,
    AddUserGroupModule,
    AssignDeviceGroupModule,
    AccessPointBuildingsModule,
    AccessTimeModule,
  ],
  exports: [UserProfileGroupComponent],
})
export class UserProfileGroupModule {}
